<script>
  import Order from './Order.svelte';
</script>

<h5>&nbsp;> Order</h5>
<br />
<Order mode="order" />
